<div @fadeInUpAnimation class="grid">
  <h1 class="text-2xl md:text-3xl mb-8" [ngClass]="{ 'text-center': isMobile$ | async }">
    Which features are you most interested in?
  </h1>

  <p class="mb-6" [ngClass]="{ 'text-center': isMobile$ | async }">
    Select
    <span class="underline">all</span>
    that apply so we can tailor your onboarding experience to help you get started.
  </p>

  <div
    class="grid gap-x-28 gap-y-8 justify-self-center"
    [ngClass]="(isMobile$ | async) ? 'grid-cols-1' : 'grid-cols-[1fr_1fr]'">
    <div
      *ngFor="let feature of features"
      class="grid grid-cols-[auto_1fr] items-center gap-4 px-4 py-2 rounded-lg border cursor-pointer shadow-md transition-shadow duration-100 hover:shadow-lg"
      [ngClass]="
        feature.selected ? 'border-raspberry-darker outline outline-1 outline-raspberry-darker' : 'border-night-lighter'
      "
      (click)="toggleFeature(feature)">
      <sbnb-icon class="text-raspberry-darker" [size]="24" [icon]="feature.icon"></sbnb-icon>
      <div>
        <div class="text-xl font-bold">{{ feature.name }}</div>
        <div class="text-sm text-night" [innerHTML]="feature.description"></div>
      </div>
    </div>
    <div></div>
    <sbnb-button
      class="block"
      [fullWidth]="true"
      [loading]="loading"
      [disabled]="!hasSelectedFeatures"
      (clicked)="onContinue()">
      Continue
    </sbnb-button>
  </div>
</div>
